export const home = {
  landingHeroTagline:
    "Ανακαλύψτε ανακατασκευασμένα εξαρτήματα, υπηρεσίες και κυκλικές λύσεις για βιώσιμη βιομηχανία.",
  landingHeroWindAlt: "Αιολικά πάρκα που παράγουν ανανεώσιμη ενέργεια",
  landingHeroBatteryAlt:
    "Μπαταρίες ηλεκτρικών οχημάτων για επαναχρησιμοποίηση",
  landingHeroRemanufacturingAlt:
    "Μονάδα ανακατασκευής με κυκλική ροή παραγωγής",
  landingPillarWindTitle: "Ανανεώσιμη ενέργεια",
  landingPillarWindDesc:
    "Στοιχεία αιολικής και πράσινης ενέργειας με δεύτερη ζωή μέσω πιστοποιημένης ανακατασκευής.",
  landingPillarBatteryTitle: "Μπαταρίες EV & αποθήκευση",
  landingPillarBatteryDesc:
    "Πακέτα και μονάδες μπαταριών ανακαινισμένα για ηλεκτροκίνηση και στατική αποθήκευση.",
  landingPillarRemanufacturingTitle: "Ανακατασκευασμένα προϊόντα",
  landingPillarRemanufacturingDesc:
    "Βιομηχανικά εξαρτήματα στην προδιαγραφή—λιγότερα απόβλητα και πρώτες ύλες.",
  landingPillarCircularityTitle: "Κυκλική ιχνηλασιμότητα",
  landingPillarCircularityDesc:
    "Ψηφιακά διαβατήρια προϊόντων και διαφανή δεδομένα κύκλου ζωής στην εφοδιαστική αλυσίδα.",
};
